const settle = {
  'settle.title': 'فاتورة التسوية',
  'settle.goSettle': 'انتقال للتسوية',
  'settle.productInfo': 'معلومات المنتج',
  'settle.table.column.index': 'الرقم التسلسلي',
  'settle.table.column.image': 'صورة المنتج',
  'settle.table.column.detail': 'تفاصيل الملحقات',
  'settle.table.column.replaceNumber': 'رقم الاستبدال',
  'settle.table.column.price': 'السعر',
  'settle.table.column.quantity': 'الكمية',
  'settle.selected': 'تم اختيار {count} سلعة',
  'settle.totalQuantity': 'إجمالي الكمية {quantity} قطعة',
  'settle.goToOrder': 'انتقال للطلب',

  'settle.deliveryMethod': 'متطلبات التوصيل',
  'settle.deliveryMethod.placeholder': 'يرجى تحديد متطلبات التوصيل',
  'settle.deliveryMethod.normal': 'قياسي',
  'settle.deliveryMethod.normal.desc': 'قنوات النقل البري العامة',
  'settle.deliveryMethod.urgent': 'عاجل', // 加急
  'settle.deliveryMethod.urgent.desc':
    'سيتم معالجة الطلب وتنظيم الشحن الجوي أولاً، مع زمن توصيل أسرع وتكلفة أعلى',

  // رسائل التحقق من صحة النموذج والعمليات
  'settle.form.validation.error': 'يرجى التحقق من حقول النموذج',
  'settle.address.required': 'يرجى اختيار عنوان التوصيل',
  'settle.product.required': 'يرجى اختيار منتج واحد على الأقل',
  'settle.order.submitting': 'جاري تقديم الطلب...',
  'settle.order.success': 'تم تقديم الطلب بنجاح',
  'settle.order.failed': 'فشل في تقديم الطلب',
  'settle.order.retry': 'فشل في تقديم الطلب، يرجى المحاولة مرة أخرى',

  'settle.message.invalidSelectedProducts': 'بعض كميات البضائع لا تفي بالمتطلبات، يرجى التأكد',

  'settle.order.failedModal.title': 'فشل في تقديم الطلب، كمية المنتجات في الجدول لا تفي بالمتطلبات',
  'settle.order.failedModal.content':
    'يجب أن يكون عدد المنتجات أكبر من الحد الأدنى ومضاعف لعدد المنتجات المباعة. يرجى تعديل كمية الطلب وإعادة المحاولة.',
  'settle.order.failedModal.product': 'اسم المنتج',
  'settle.order.failedModal.quantity': 'الكمية الحالية',
  'settle.order.failedModal.min_sale_count': 'الحد الأدنى',
  'settle.order.failedModal.multiple_sale_count': 'الكمية المباعة',
  'settle.order.failedModal.error_message': 'رسالة الخطأ',
};

export default settle;
